export default "__VITE_ASSET__BSwi9x3x__"